import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=0b3075f4&"
import script from "./AllOrders.vue?vue&type=script&lang=js&"
export * from "./AllOrders.vue?vue&type=script&lang=js&"
import style0 from "./AllOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports